<template>
  <div :class="[customClass]">
    <!-- Cas avec un message + lien -->
    <Message
      v-if="message"
      severity="secondary"
      :closable="false"
    >
      <span v-html="message" />
      <br />
      <SpmButton
        v-if="link"
        :label="link.label"
        icon="fa-regular fa-circle-info"
        class-style="help-button p-button p-button-secondary"
        @click.prevent="handleClick"
      />
    </Message>

    <!-- Cas sans message : juste le lien -->
    <a
      v-else-if="link"
      href="javascript:void(0);"
      class="help-link"
      @click.prevent="handleClick"
    >
      <i
        v-if="!showExternalIcon"
        class="fa-regular fa-circle-info"
        style="margin-right: 4px;"
      /> {{ link.label }}
      <i
        v-if="showExternalIcon"
        class="fa-solid fa-arrow-up-right-from-square"
        style="margin-left: 4px;"
      />
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { openHelp } from '@/helpers/Gleap';
import Message from 'primevue/message';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';

export default defineComponent({
  name: 'HelpMessage',

  components: {
    SpmButton,
    Message,
  },

  props: {
    message: {
      type: String,
      required: false,
      default: undefined,
    },

    link: {
      type: Object as () => {
        type: 'gleap' | 'external';
        articleId?: string;
        url?: string;
        label: string;
      },

      required: true,
    },

    customClass: {
      type: String,
      required: false,
      default: '',
    },
  },

  setup(props) {
    const showExternalIcon = computed(() => props.link.type === 'external');
    function handleClick() {
      if (props.link.type === 'gleap' && props.link.articleId) {
        openHelp(props.link.articleId, false);
      } else if (props.link.type === 'external' && props.link.url) {
        window.open(props.link.url, '_blank');
      }
    }

    return {
      handleClick,
      showExternalIcon,
      ...props,
    };
  },
});
</script>

<style scoped>
.help-button {
  margin-top: 10px;
}
.help-link {
  cursor: pointer;
}
.help-link i {
  margin-left: 4px;
  font-size: 0.9em;
  color: #94c840;
}
.p-message-secondary {
  color: #666;
  background-color: #f6f6f6;
  border: 0 #eee;
  position: relative;
  margin-bottom: 0;
  border-radius: .25rem;
  padding: .25rem;
  text-align: justify;

  &:deep() > a {
    color: $brand-color-primary !important;
  }
}
</style>
